
export default (self,info,surveyInfo) => {
  let columnDefs = []
  columnDefs = [
    {
      headerName: '',
      width: 30,
      field: 'rowIndex',
      hidden: true,
      suppressMovable: true,
      cellStyle: {
        textAlign: 'center',
        padding: '5px 0',
        color: '#595959',
        backgroundColor: '#f0f0f0',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '500',
        boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
      }
    },
    {
      headerName: '账号',
      field: 'userName',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '姓名',
      field: 'fullName',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '组织名称',
      field: 'orgName',
      width: 40,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '组织编码',
      field: 'orgCode',
      width: 25,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '手机号',
      field: 'mobile',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '身份证号/工号',
      field: 'idCard',
      width: 30,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '用户属性',
      field: 'userType',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '账号状态',
      field: 'disabled',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '问卷提交时间',
      field: 'submissionDate',
      width: 30,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      }
    }
  ]

  let leng = 0
  let questions = []
  if (info && info.length) {
    for (let i = 0;i< info.length; i++) {
      let iLen = info[i]['questions'].length
      for (let j = 0; j < info.length - i; j++) {
        let jLen = info[j]['questions'].length
        if (jLen > iLen) {
          leng = jLen
        } else {
          leng = iLen
        }
      }
    }

    info.forEach(e => {
      if (e['questions'] && e['questions'].length && e['questions'].length === leng) {
        questions = e['questions']
      }
    })
  }

  if (questions && questions.length === 0 ) {
    questions = surveyInfo && surveyInfo.questions
  }

  if(questions && questions.length) {
    questions.forEach(e => {
      columnDefs.push({
        headerName: e['title'],
        field: e['title'],
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        }
      })
    })
  }
  return columnDefs
}
